<template>
	<CRow>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>لینک‌های شماره</strong> 
				</CCardHeader>
				<CCardBody>
                    <CDataTable
                        hover
                        striped
                        columnFilter
                        :items="items"
                        :fields="fields"
                        :items-per-page="10"
                        :active-page="active_page"
                        :pagination="{ doubleArrows: false, align: 'center'}"
                        :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                    >
                        <template #user_name="data">
                            <td>
                                <router-link :to="`/profile/${data.item.user_id}`">
                                    {{data.item.user_name}}
                                </router-link>
                            </td>
                        </template>
                        <template #is_active="data">
                            <td v-if="data.item.is_active">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
                        <template #current_state="data">
                            <td v-if="data.item.current_state">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
                        <template #action="data">
                            <td>
                                <template>
                                    <div class="flex-container">
                                        <div @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
                    </CDataTable>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
  </CRow>
</template>

<script>
export default {
	data() {
		return {
			items: [],
			fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'url_link', label: 'لینک' },
                { key: 'is_active', label: 'وضعیت' },
                { key: 'current_state', label: 'وضعیت جاری' },
                { key: 'last_send', label: 'آخرین ارسال' },
                { key: 'action', label: 'عملیات' }
            ],
			delete_modal: false,
            id: 0,
            active_page: 1,
		}
	},
	mounted() {
		this.get();
	},
	methods: {
		get() {
            this.axios.get('user_nums/'
                + '?id=' + this.$route.params.id 
                + '&url_infos=1')
                .then(res => {
                    res.data[0].url_infos.map(val => {
                        if(val.last_send == '0001-01-01T00:00:00Z'){
                            val.last_send = '---';
                        } else {
                            val.last_send = this.$moment(val.last_send, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                        }
                    });
                    this.items = res.data[0].url_infos;
                })
		},
		delete_row() {
			this.axios.delete('user_nums/'
            + this.id
            + '/' 
            + this.$route.params.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
                this.count();
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
	},
	beforeCreate(){
        if(this.$store.state.perms.can_view_link == false
            && this.$store.state.perms.can_view_link_for_all_users == false
            && this.$store.state.perms.can_view_link_for_same_group_user == false 
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>